import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let ReferenceTables = class ReferenceTables extends VuexModule {
    constructor() {
        super(...arguments);
        this.referenceTables = [];
        this.cachedVersion = 0;
    }
    async fetchReferenceTables() {
        const { data: referenceTables, cachedVersion } = await fetchFromCache(this, 'referenceTables', 'referenceTable');
        return { referenceTables, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['referenceTables', 'cachedVersion'] })
], ReferenceTables.prototype, "fetchReferenceTables", null);
ReferenceTables = __decorate([
    Module({ namespaced: true, name: 'referenceTable' })
], ReferenceTables);
export default ReferenceTables;
